// src/controllers/datetimepicker_controller.js
import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

/**
 * Stimulus controller for initializing flatpickr datetime pickers.
 * Applies flatpickr to all elements with the .datetimepicker class.
 */
export default class extends Controller {
  /**
   * Called when the controller is connected to the DOM.
   * Initializes flatpickr with time and formatting options.
   */
  connect() {
    flatpickr('.datetimepicker', {
      enableTime: true,
      altInput: true,
      wrap: true, // Expects input to be wrapped for custom UI
      altFormat: "F j, Y @ h:i K",
      dateFormat: "Y-m-d H:i",
    });
  }
}
